import { render, staticRenderFns } from "./wxsrule.vue?vue&type=template&id=64f47971&"
import script from "./wxsrule.vue?vue&type=script&lang=js&"
export * from "./wxsrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports